import { SourceType } from 'module/api/filter/types';
import { asUserMetaData } from 'module/helpers/filter/as-user-field-meta';
import { useTranslation } from 'module/hooks/use-translation';
import { FieldType } from 'module/types/filter-field/field/field';
import { MultiUserField } from 'module/types/filter-field/field/filterable-field';
import { useGetAllActiveExternalUsersQuery } from 'queries/member';
import { useMemo } from 'react';

export const useReportingUsersField = (
  fieldId: number,
): {
  field: MultiUserField;
  isLoading: boolean;
} => {
  const { data: externalUsers, isLoading: isUserLoading } =
    useGetAllActiveExternalUsersQuery();
  const fieldLabel = useTranslation('signal.fields.reported_by');

  return useMemo(
    () => ({
      field: {
        fieldId,
        fieldName: 'reportedBy',
        fieldLabel,
        type: FieldType.MultiUser,
        private: false,
        userCreated: false,
        metaData: asUserMetaData(externalUsers ?? []),
        sourceType: SourceType.Signal,
      },
      isLoading: isUserLoading,
    }),
    [fieldId, isUserLoading, fieldLabel, externalUsers],
  );
};
